var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgFill2 = function SvgBgFill2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359,
    height: 121,
    fill: "none",
    viewBox: "0 0 359 121"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 18.5,
    r: 1.5,
    fill: "#01B2FE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 355.5,
    cy: 24.5,
    r: 1.5,
    fill: "#01B2FE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 119,
    r: 1,
    fill: "#01B2FE",
    fillOpacity: 0.7
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 44,
    r: 1,
    fill: "#01B2FE",
    fillOpacity: 0.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 339,
    cy: 2,
    r: 1,
    fill: "#01B2FE",
    fillOpacity: 0.7
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 8,
    r: 1,
    fill: "#01B2FE",
    fillOpacity: 0.7
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 89.5,
    r: 2.5,
    fill: "#01B2FE"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_7874_5974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 18.5,
    r: 2.5,
    fill: "#01B2FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7874_5974",
    width: 7,
    height: 7,
    x: 91,
    y: 15,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7874_5974",
    width: 7,
    height: 7,
    x: 352,
    y: 21,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7874_5974",
    width: 4,
    height: 4,
    x: 4,
    y: 117,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_7874_5974",
    width: 4,
    height: 4,
    x: 47,
    y: 42,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_7874_5974",
    width: 4,
    height: 4,
    x: 337,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_7874_5974",
    width: 4,
    height: 4,
    x: 216,
    y: 6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_7874_5974",
    width: 11,
    height: 11,
    x: 0,
    y: 84,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 1.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_7874_5974",
    width: 11,
    height: 11,
    x: 241,
    y: 13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7874_5974",
    stdDeviation: 1.5
  })))));
};
export default SvgBgFill2;